import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../config/endpoints'

export const useProjectById = (projectId: string) => {
  const endpoint = ENDPOINTS.PROJECTS.get
  const p = projectId ? endpoint + '/' + projectId : null
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
